var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhonePortraitOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 0.5625H6.1875C5.25552 0.5625 4.5 1.31802 4.5 2.25V15.75C4.5 16.682 5.25552 17.4375 6.1875 17.4375H11.8125C12.7445 17.4375 13.5 16.682 13.5 15.75V2.25C13.5 1.31802 12.7445 0.5625 11.8125 0.5625Z",
    stroke: "#FFDB70",
    strokeWidth: 1.23047,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 0.5625H7.03125C7.10584 0.5625 7.17738 0.592132 7.23012 0.644876C7.28287 0.697621 7.3125 0.769158 7.3125 0.84375C7.3125 0.992934 7.37176 1.13601 7.47725 1.2415C7.58274 1.34699 7.72582 1.40625 7.875 1.40625H10.125C10.2742 1.40625 10.4173 1.34699 10.5227 1.2415C10.6282 1.13601 10.6875 0.992934 10.6875 0.84375C10.6875 0.769158 10.7171 0.697621 10.7699 0.644876C10.8226 0.592132 10.8942 0.5625 10.9688 0.5625H11.8125",
    stroke: "#FFDB70",
    strokeWidth: 1.23047,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePortraitOutline);
export default __webpack_public_path__ + "static/media/phone-portrait-outline.3326dda1a96ff6439725340200a5d511.svg";
export { ForwardRef as ReactComponent };